/// return the same value as pilote/frontend/src/helpers/Converters.ts transportIdToLetters
export function piloteIdToLetter(piloteId: number) {
  const output = []
  // Will give us A to ZZ max: (26*26+26 = 702)
  let dividend = ((piloteId - 1) % 702) + 1
  while (dividend > 0) {
    const modulo = (dividend - 1) % 26
    output.unshift(String.fromCodePoint(65 + modulo))
    dividend = Math.floor((dividend - modulo) / 26)
  }
  return output.join('')
}
